<template>
  <svg width="25" height="25" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="15" fill="#42526E"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15 23C12.8783 23 10.8434 22.1571 9.34315 20.6569C7.84285 19.1566 7 17.1217 7 15C7 12.8783 7.84285 10.8434 9.34315 9.34315C10.8434 7.84285 12.8783 7 15 7C17.1217 7 19.1566 7.84285 20.6569 9.34315C22.1571 10.8434 23 12.8783 23 15C23 17.1217 22.1571 19.1566 20.6569 20.6569C19.1566 22.1571 17.1217 23 15 23ZM16.364 12.036L14.212 16.146L12.669 14.756C12.5714 14.6681 12.4574 14.6004 12.3336 14.5566C12.2097 14.5128 12.0785 14.4938 11.9473 14.5007C11.8162 14.5076 11.6876 14.5403 11.5691 14.5969C11.4506 14.6535 11.3444 14.7329 11.2565 14.8305C11.1686 14.9281 11.1009 15.0421 11.0571 15.1659C11.0133 15.2898 10.9943 15.421 11.0012 15.5522C11.0081 15.6833 11.0408 15.8119 11.0974 15.9304C11.154 16.0489 11.2334 16.1551 11.331 16.243L13.831 18.493C13.9443 18.595 14.0794 18.6698 14.226 18.7116C14.3726 18.7534 14.5268 18.7611 14.6768 18.7342C14.8268 18.7073 14.9687 18.6464 15.0917 18.5563C15.2146 18.4661 15.3153 18.349 15.386 18.214L18.136 12.964C18.2591 12.729 18.2837 12.4548 18.2046 12.2016C18.1255 11.9484 17.949 11.7371 17.714 11.614C17.479 11.4909 17.2048 11.4663 16.9516 11.5454C16.6984 11.6245 16.4871 11.801 16.364 12.036Z" fill="white"/>
  </svg>
</template>

<script>
export default {

}
</script>

<style>

</style>
